import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-section-home-links-destacados',
  templateUrl: './section-home-links-destacados.component.html',
  styleUrls: ['./section-home-links-destacados.component.scss']
})
export class SectionHomeLinksDestacadosComponent implements OnInit {

  urlEnlace = '/assets/img/web/principal/enlaces/';

  buttons = [
    { icon: this.urlEnlace + '2.svg', hover: this.urlEnlace + '2-hover.svg', isHover: false, enlace: 2 },
    { icon: this.urlEnlace + '3.svg', hover: this.urlEnlace + '3-hover.svg', isHover: false, enlace: 3 },
  ];

  constructor() {

  }

  ngOnInit() {
  }
  
  onMouseInto = (tipo) => {

  }

  onMouseOut = (tipo) => {

  }

  irEnlace = (tipo) => {
    switch (tipo) {
      case 2:
        window.open("https://www.sunedu.gob.pe/instituciones-con-rango-universitario/","_blank");
        break;
      case 3:
        window.open("https://www.sunedu.gob.pe/lista-de-universidades-denegadas/","_blank");
        break;
    }

  }


}
